import { DataTableV2, Intro } from "components/commons";
import { DownloadProgressModal } from "components/modals";
import { locale } from "localization/en";
import DetailedTransactionHistoryFilter from "./detailed-transaction-history-filter";
import { useContext } from "react";
import { StationContext } from "contexts";
import { detailedTransactionHistoryColumn } from "./detailed-transaction-history-list-column";
import { mapDataToList, mapFilterToRequest } from "./detailed-transaction-history-list-mapper";
import { initialFilterState } from "./detailed-transaction-history-filter.state";
import useDataTable from "hooks/useDataTable";
import { getTransactions } from "apis/transactions";
import { generateReport } from "apis/generate-report.api";
import useExport from "hooks/useExport";
import styles from "./detailed-transaction-history-list.module.scss";

const DetailedTransactionHistoryModule = () => {
  const { station } = useContext(StationContext);

  const { filter, search, table } = useDataTable({
    api: {
      api: getTransactions,
      params: {
        page: 1,
        perPage: 10,
        stationCode: station.stationCode,
      },
      mapper: (param) => {
        return param;
      },
    },
    filter: { initialState: initialFilterState(), mapper: mapFilterToRequest },
    table: {
      key: "transactions",
      mapper: (transactions) => mapDataToList({ transactions, station }),
      columns: detailedTransactionHistoryColumn,
    },
  });

  const exports = useExport({
    api: generateReport,
    reportType: "detailed-transaction",
    mappedFilterState: {
      ...filter?.mappedFilterState,
      stationCode: station.stationCode,
      searchKey: search?.searchKey,
    },
  });

  return (
    <div>
      <DownloadProgressModal {...exports.downloadProgressModal} />
      <Intro title={locale.detailedTransactionHistoryReport} />
      <DetailedTransactionHistoryFilter {...filter} {...search} {...exports} />

      <div className={styles.topAligned}>
        <DataTableV2 {...table} />
      </div>
    </div>
  );
};

export default DetailedTransactionHistoryModule;
